"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
class IgnoreAndBlockControlService {
    constructor(preferencesStorageService) {
        this.preferencesStorageService = preferencesStorageService;
    }
    getPreferences() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.preferencesStorageService.getPreferencesIgnoreAndBlock();
        });
    }
    addUserToBlockWhiteList(user) {
        return __awaiter(this, void 0, void 0, function* () {
            const preferences = yield this.preferencesStorageService.getPreferencesIgnoreAndBlock();
            preferences.blockWhiteList.push(user);
            yield this.preferencesStorageService.storePreferencesIgnoreAndBlock(preferences);
        });
    }
    addUserToBlockBlackList(user) {
        return __awaiter(this, void 0, void 0, function* () {
            const preferences = yield this.preferencesStorageService.getPreferencesIgnoreAndBlock();
            preferences.blockBlackList.push(user);
            yield this.preferencesStorageService.storePreferencesIgnoreAndBlock(preferences);
        });
    }
    addUserToIgnoreWhiteList(user) {
        return __awaiter(this, void 0, void 0, function* () {
            const preferences = yield this.preferencesStorageService.getPreferencesIgnoreAndBlock();
            preferences.ignoreWhiteList.push(user);
            yield this.preferencesStorageService.storePreferencesIgnoreAndBlock(preferences);
        });
    }
    addUserToIgnoreBlackList(user) {
        return __awaiter(this, void 0, void 0, function* () {
            const preferences = yield this.preferencesStorageService.getPreferencesIgnoreAndBlock();
            preferences.ignoreBlackList.push(user);
            yield this.preferencesStorageService.storePreferencesIgnoreAndBlock(preferences);
        });
    }
    removeUserFromBlockWhiteList(user) {
        return __awaiter(this, void 0, void 0, function* () {
            const preferences = yield this.preferencesStorageService.getPreferencesIgnoreAndBlock();
            preferences.blockWhiteList = preferences.blockWhiteList.filter((iu) => {
                return iu.publicKey !== user.publicKey;
            });
            yield this.preferencesStorageService.storePreferencesIgnoreAndBlock(preferences);
        });
    }
    removeUserFromBlockBlackList(user) {
        return __awaiter(this, void 0, void 0, function* () {
            const preferences = yield this.preferencesStorageService.getPreferencesIgnoreAndBlock();
            preferences.blockBlackList = preferences.blockBlackList.filter((iu) => {
                return iu.publicKey !== user.publicKey;
            });
            yield this.preferencesStorageService.storePreferencesIgnoreAndBlock(preferences);
        });
    }
    removeUserFromIgnoreWhiteList(user) {
        return __awaiter(this, void 0, void 0, function* () {
            const preferences = yield this.preferencesStorageService.getPreferencesIgnoreAndBlock();
            preferences.ignoreWhiteList = preferences.ignoreWhiteList.filter((iu) => {
                return iu.publicKey !== user.publicKey;
            });
            yield this.preferencesStorageService.storePreferencesIgnoreAndBlock(preferences);
        });
    }
    removeUserFromIgnoreBlackList(user) {
        return __awaiter(this, void 0, void 0, function* () {
            const preferences = yield this.preferencesStorageService.getPreferencesIgnoreAndBlock();
            preferences.ignoreBlackList = preferences.ignoreBlackList.filter((iu) => {
                return iu.publicKey !== user.publicKey;
            });
            yield this.preferencesStorageService.storePreferencesIgnoreAndBlock(preferences);
        });
    }
    setBlockWhiteListEnabled(enabled) {
        return __awaiter(this, void 0, void 0, function* () {
            const preferences = yield this.preferencesStorageService.getPreferencesIgnoreAndBlock();
            preferences.isBlockWhiteListEnabled = enabled;
            if (enabled) {
                preferences.isBlockBlackListEnabled = false;
            }
            yield this.preferencesStorageService.storePreferencesIgnoreAndBlock(preferences);
        });
    }
    setBlockBlackListEnabled(enabled) {
        return __awaiter(this, void 0, void 0, function* () {
            const preferences = yield this.preferencesStorageService.getPreferencesIgnoreAndBlock();
            preferences.isBlockBlackListEnabled = enabled;
            yield this.preferencesStorageService.storePreferencesIgnoreAndBlock(preferences);
        });
    }
    setIgnoreWhiteListEnabled(enabled) {
        return __awaiter(this, void 0, void 0, function* () {
            const preferences = yield this.preferencesStorageService.getPreferencesIgnoreAndBlock();
            preferences.isIgnoreWhiteListEnabled = enabled;
            if (enabled) {
                preferences.isIgnoreBlackListEnabled = false;
            }
            yield this.preferencesStorageService.storePreferencesIgnoreAndBlock(preferences);
        });
    }
    setIgnoreBlackListEnabled(enabled) {
        return __awaiter(this, void 0, void 0, function* () {
            const preferences = yield this.preferencesStorageService.getPreferencesIgnoreAndBlock();
            preferences.isIgnoreBlackListEnabled = enabled;
            yield this.preferencesStorageService.storePreferencesIgnoreAndBlock(preferences);
        });
    }
    addTransactionHashesToBlock(hashes) {
        return __awaiter(this, void 0, void 0, function* () {
            const preferences = yield this.preferencesStorageService.getPreferencesIgnoreAndBlock();
            for (const hash of hashes) {
                if (preferences.blockedTransactionHashes.indexOf(hash) === -1) {
                    preferences.blockedTransactionHashes.push(hash);
                }
            }
            yield this.preferencesStorageService.storePreferencesIgnoreAndBlock(preferences);
        });
    }
    clearTransactionHashesToBlock() {
        return __awaiter(this, void 0, void 0, function* () {
            const preferences = yield this.preferencesStorageService.getPreferencesIgnoreAndBlock();
            preferences.blockedTransactionHashes = [];
            yield this.preferencesStorageService.storePreferencesIgnoreAndBlock(preferences);
        });
    }
}
exports.IgnoreAndBlockControlService = IgnoreAndBlockControlService;
